import { render, staticRenderFns } from "./anamneseExame2.vue?vue&type=template&id=6dfc32ec&scoped=true"
import script from "./anamneseExame2.vue?vue&type=script&lang=js"
export * from "./anamneseExame2.vue?vue&type=script&lang=js"
import style0 from "./anamneseExame2.vue?vue&type=style&index=0&id=6dfc32ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc32ec",
  null
  
)

export default component.exports